import { Button, Checkbox, Flex, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Description,
  ModalList,
  ModalSubtitle,
  SyncSection,
  Title,
  Wrapper
} from './ImportContentDrawerFooter.styles';

import { Icon } from '@/components/Icon';

type ImportContentDrawerFooterProps = {
  isLoading?: boolean;
  isSyncedToParent: boolean;
  onSyncChange: (checked: boolean) => void;
  onCancel: () => void;
  onImport: () => void;
  isImportDisabled: boolean;
  showSyncCheckbox?: boolean;
  isActivityImport?: boolean;
};

const MODAL_WIDTH = 572;

export const ImportContentDrawerFooter: React.FC<ImportContentDrawerFooterProps> = ({
  isLoading,
  isSyncedToParent,
  onSyncChange,
  onCancel,
  onImport,
  isImportDisabled,
  showSyncCheckbox,
  isActivityImport
}) => {
  const { t } = useTranslation(['CourseTranslations', 'DefaultTranslations']);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleCheckboxChange = (checked: boolean) =>
    !isSyncedToParent && checked ? setIsConfirmModalOpen(true) : onSyncChange(checked);

  const handleConfirmSync = () => {
    onSyncChange(true);
    setIsConfirmModalOpen(false);
  };

  return (
    <Wrapper>
      {showSyncCheckbox && (
        <SyncSection>
          <Title>
            {isActivityImport
              ? t('CourseTranslations:SYNC_WITH_PARENT_FOOTER_TITLE_ACTIVITY')
              : t('CourseTranslations:SYNC_WITH_PARENT_FOOTER_TITLE')}
          </Title>
          <Description>
            {isActivityImport
              ? t('CourseTranslations:SYNC_WITH_PARENT_FOOTER_DESCRIPTION_ACTIVITY')
              : t('CourseTranslations:SYNC_WITH_PARENT_FOOTER_DESCRIPTION')}{' '}
            <Icon i="Renew" />
          </Description>
          <Checkbox
            checked={isSyncedToParent}
            onChange={e => handleCheckboxChange(e.target.checked)}>
            {isActivityImport
              ? t('CourseTranslations:SYNC_WITH_PARENT_ACTIVITY')
              : t('CourseTranslations:SYNC_WITH_PARENT')}
          </Checkbox>
        </SyncSection>
      )}
      <Flex gap={16} justify="flex-end" align="center">
        <Button disabled={isLoading} onClick={onCancel}>
          {t('DefaultTranslations:CANCEL')}
        </Button>
        <Button type="primary" disabled={isImportDisabled} loading={isLoading} onClick={onImport}>
          {t('DefaultTranslations:IMPORT')}
        </Button>
      </Flex>

      <Modal
        title={t('CourseTranslations:SYNC_CONFIRM_TITLE')}
        open={isConfirmModalOpen}
        onOk={handleConfirmSync}
        centered
        width={MODAL_WIDTH}
        onCancel={() => setIsConfirmModalOpen(false)}
        okText={t('CourseTranslations:CONFIRM_SYNC_BUTTON')}
        cancelText={t('DefaultTranslations:CANCEL')}>
        <ModalSubtitle>{t('CourseTranslations:SYNC_CONFIRM_SUBTITLE')}</ModalSubtitle>
        <ModalList>
          <li>{t('CourseTranslations:SYNC_CONFIRM_ITEM_1')}</li>
          <li>{t('CourseTranslations:SYNC_CONFIRM_ITEM_2')}</li>
          <li>{t('CourseTranslations:SYNC_CONFIRM_ITEM_3')}</li>
        </ModalList>
      </Modal>
    </Wrapper>
  );
};
